(() => {
  if (window.hanatabaKachingThemeSyncLoaded) return;
  window.hanatabaKachingThemeSyncLoaded = true;

  let selectedKachingPrice = '';
  let selectedKachingComparePrice = '';

  function getKachingBlock() {
    return (
      document.querySelector(
        'product-form kaching-bundles-block'
      ) ||
      document.querySelector('kaching-bundles-block')
    );
  }

  function getMainAddButton(block = getKachingBlock()) {
    const productForm =
      block?.closest('product-form') ||
      document.querySelector('product-form.js-product');

    return (
      productForm?.querySelector(
        'button.add-to-cart[name="add"]'
      ) || null
    );
  }

  function getStickyAddButton() {
    return document.querySelector(
      'sticky-atc button.add-to-cart[name="add"]'
    );
  }

function showPriceInButton(
  button,
  formattedPrice,
  formattedComparePrice = ''
) {
  if (!button || !formattedPrice) return;

  const stickyPrice = button.querySelector(
    '.sticky-atc__button-price'
  );

  const stickyComparePrice = button.querySelector(
    '.sticky-atc__button-compare-price'
  );

  const displayedPrice = stickyPrice
    ? stickyPrice.textContent.trim()
    : button.textContent.trim();

  const displayedComparePrice =
    stickyComparePrice?.textContent.trim() || '';

  const priceIsCorrect =
    displayedPrice.includes(formattedPrice);

  const comparePriceIsCorrect =
    !stickyPrice ||
    (
      formattedComparePrice
        ? displayedComparePrice === formattedComparePrice &&
          !stickyComparePrice.hidden
        : !displayedComparePrice ||
          stickyComparePrice.hidden
    );

  if (
    button.dataset.kachingPrice === formattedPrice &&
    button.dataset.kachingComparePrice ===
      formattedComparePrice &&
    priceIsCorrect &&
    comparePriceIsCorrect
  ) {
    return;
  }

  const stickyLabel = button.querySelector(
    '.sticky-atc__button-label'
  );

  const addToCartText =
    button.dataset.addToCartText ||
    stickyLabel?.textContent.trim() ||
    button.textContent.split('•')[0].trim();

  if (!button.dataset.addToCartText && addToCartText) {
    button.dataset.addToCartText = addToCartText;
  }

  button.dataset.kachingPrice = formattedPrice;
  button.dataset.kachingComparePrice =
    formattedComparePrice;

  if (stickyPrice) {
    const stickyIcon = button.querySelector(
      '.sticky-atc__button-icon'
    );

    const stickySeparator = button.querySelector(
      '.sticky-atc__button-separator'
    );

    if (stickyLabel) {
      stickyLabel.textContent = addToCartText;
    }

    if (stickyIcon) stickyIcon.hidden = false;
    if (stickySeparator) stickySeparator.hidden = false;

    stickyPrice.textContent = formattedPrice;
    stickyPrice.hidden = false;

    if (stickyComparePrice) {
      const showComparePrice =
        formattedComparePrice &&
        formattedComparePrice !== formattedPrice;

      stickyComparePrice.textContent =
        showComparePrice ? formattedComparePrice : '';

      stickyComparePrice.hidden = !showComparePrice;
    }

    return;
  }

  button.innerHTML =
    `${addToCartText}` +
    `<span aria-hidden="true"> • </span>` +
    `${formattedPrice}`;
}

 function updateKachingPrice(detail, block) {
  const formattedPrice = detail?.formattedPrice;

  const formattedComparePrice =
    detail?.pricing?.fullPrice?.formatted || '';

  if (!formattedPrice) return;

  selectedKachingPrice = formattedPrice;
  selectedKachingComparePrice =
    formattedComparePrice;

  showPriceInButton(
    getMainAddButton(block),
    formattedPrice,
    formattedComparePrice
  );

  showPriceInButton(
    getStickyAddButton(),
    formattedPrice,
    formattedComparePrice
  );
}

  function connectKachingBlock(block) {
    if (
      !block ||
      block.dataset.hanatabaKachingSync === 'true'
    ) {
      return;
    }

    block.dataset.hanatabaKachingSync = 'true';

    block.addEventListener(
      'variants-changed',
      (event) => {
        updateKachingPrice(event.detail, block);
      }
    );
  }

  function connectAllKachingBlocks() {
    document
      .querySelectorAll('kaching-bundles-block')
      .forEach(connectKachingBlock);
  }

  function initializeKachingSync() {
    connectAllKachingBlocks();

    document.addEventListener(
      'click',
      (event) => {
        const target =
          event.target instanceof Element
            ? event.target
            : null;

        const stickyButton = target?.closest(
          'sticky-atc button.add-to-cart[name="add"]'
        );

        if (!stickyButton) return;

        const kachingBlock = getKachingBlock();
        const mainButton =
          getMainAddButton(kachingBlock);

        if (
          !kachingBlock ||
          !mainButton ||
          mainButton.disabled
        ) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        mainButton.click();
      },
      true
    );

    const observer = new MutationObserver(() => {
  connectAllKachingBlocks();
});

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeKachingSync
    );
  } else {
    initializeKachingSync();
  }
})();